module.exports = __webpack_public_path__ + "static/assets/8153a7b93982b4b43891c442eddbdce7.png";